import React from 'react'
import { UsefullLinksSet, test } from '../../../Status'
const Links = () => {
    
  return (
    <div>
      <div className="Archive-Table-Search">
                <h1>Usefull Links :</h1>
                
              </div>
      <div className="table-container">
      <table className="archive-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Full Name</th>
            <th>Type</th>
            <th>Level</th>
            <th>Region</th>
            <th>Focus</th>
            <th>Link</th>
          </tr>
        </thead>
        <tbody>
          {UsefullLinksSet.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>{item.fullName}</td>
              <td>{item.type}</td>
              <td>{item.level}</td>
              <td>{item.region}</td>
              <td>{item.focus}</td>
              <td><a href={item.url}>Website</a></td>
              
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  )
}

export default Links
